module.exports = __webpack_public_path__ + "8630a5e0582753d801adb83cb2faec38.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/203.png
// module id = 1774
// module chunks = 2